module.exports = __webpack_public_path__ + "img/1.dc055ef9.jpg";